import { Handler } from 'app/types/handlers';
import { Component, OnInit, Input, AfterContentInit, ChangeDetectorRef, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
export type SearchFilterModes = 'search' | 'filter';

export type SearchFilterSelectItem = {
  id: any;
  label: string;
}

export type SearchConfig = {
  searchHandler?: (term:string, setResults:Handler<Array<any>,void>)=>{} | void;
  getItemLabel?: Handler<any, string>;
  selectHandler?: Handler<any, void>;
}

export type FilterConfig = {
  filter?: Handler<any, -1 | 1 | 0>;
  filterSource?: Array<any>;
}

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchFilterComponent implements AfterContentInit {
  @Input('label') label: string = 'find';
  @Input('mode') mode: SearchFilterModes = 'search';
  @Input('config') config?: SearchConfig | FilterConfig;

  public results?: Array<any>;
  private _searchTerm = '';
  public get searchTerm(): string {
    return this._searchTerm;
  }
  public set searchTerm(term: string) {
    this._searchTerm = term;
    this.HandleTermUpdate();
  }

  public get filtering(): boolean {
    return this.mode === 'filter';
  }
  public get searching(): boolean {
    return this.mode === 'search';
  }
  public get hasResults(): boolean {
    if (!this.results) return false;
    return this.results.length > 0;
  }
  private _ready: boolean = false;
  constructor(private cdr: ChangeDetectorRef) { }

  ngAfterContentInit(): void {
    this._ready = true;
    this.Refresh();
    this.HandleTermUpdate();
  }
  HandleTermUpdate() {
    if (!this.config) return;
    switch (this.mode) {
      case 'search':
        this.Search();
        break;
      case 'filter':
        this.Filter();
        break;
    }
    // do something cool;
  }
  Search() {
    const config = this.config as SearchConfig;
    if (config?.searchHandler) {
      config.searchHandler(this.searchTerm,
        (results: Array<any>) => {
          if (results) {
            this.results = results;
            this.hasResults;
            this.Refresh();
          }
        }
      );
    }
  }
  Filter() {
    const config = this.config as FilterConfig;
    if (!config?.filterSource) return;
    config.filterSource.filter((any) => {
      if (!config?.filter) {
        return (config.filterSource!.indexOf(any) > -1);
      };
      return config.filter(any);
    });
  }
  ClearSearch() {
    this.searchTerm = '';
    this.Refresh();
  }
  GetLabel(item: any): string {
    const config = this.config as SearchConfig;
    if (config?.getItemLabel) {
      return config.getItemLabel(item);
    }
    if (item.label) return item.label;
    return '';
  }
  Select(item: any) {
    const config = this.config as SearchConfig;
    if (config?.selectHandler) {
      config.selectHandler(item);
    }
  }
  Refresh() {
    if (this._ready === false) return;
    this.cdr.detectChanges();
  }

}
